<div style="position: relative; box-sizing: content-box; width: 100%; aspect-ratio: 1.8">
  <iframe
    [src]="iframeUrl | safeHtml"
    loading="lazy"
    [title]="iframeTitle"
    allow="clipboard-write"
    frameborder="0"
    webkitallowfullscreen="true"
    mozallowfullscreen="true"
    allowfullscreen
    style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"></iframe>
</div>
